import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { WhiteLabelService } from '@flexyoo/common';
import { employeeSelectedBenefitsSelectors } from '@flexyoo/employee/store';
import { FlexyooNumberPipe } from '@flexyoo/shared/pipes';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { EmployeeBasketProgressBarComponent } from '../employee-basket-progress-bar/employee-basket-progress-bar.component';

@Component({
  selector: 'flexyoo-employee-ss-basket-info',
  templateUrl: './employee-ss-basket-info.component.html',
  styleUrl: './employee-ss-basket-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    MatIconModule,
    FlexyooNumberPipe,
    EmployeeBasketProgressBarComponent,
    UpperCasePipe,
  ],
})
export class EmployeeSsBasketInfoComponent {
  private readonly store = inject(Store);

  protected readonly wls = inject(WhiteLabelService);
  protected readonly PER_MONTH_COEFF = 13.92;

  protected readonly ssBasket = toSignal(
    this.store.select(employeeSelectedBenefitsSelectors.selectSSBasket)
  );
}
